import React, {useEffect, useRef, useState} from "react";
import axios from "axios";
import {API_URL} from "../../../utils/Common";
import MyLoader from "../../sharecomponents/MyLoader";
import CantidadPlan from "./CantidadPlan";
import SelectFlores from "../../sharecomponents/SelectFlores";
import {
    ToastsContainer,
    ToastsContainerPosition,
    ToastsStore,
} from "react-toasts";
import Modal from "../../sharecomponents/Modal";

const PlanCosechaGenerados = (props) => {
    // modal
    const modalRef = useRef();
    // -- loader
    const [loader, updateLoader] = useState(false);
    const [datosPlan, updateDatosPlan] = useState([]);
    const [sumaVer, updateSumVer] = useState([]);
    const [flor, setFlor] = useState({flor: 0});

    const [infoFlor, setInfoFlor] = useState({});

    function getPlanes() {
        updateLoader(true);
        axios.get(API_URL + "/getPlanCosecha").then((r) => {
            updateDatosPlan(r.data.datos);
            updateSumVer(r.data.sv);
            updateLoader(false);
        }).catch(e => {
            console.log(e);
            updateLoader(false);
        });
    }

    useEffect(() => {
        getPlanes();
    }, []);

    function actualizarDatos(cantidad, pf, ps) {
        datosPlan[pf].sumaHor = 0;
        datosPlan[pf].cantidades[ps] = +cantidad;
        //-- suma horizontal
        for (let i = 0; i < datosPlan[pf].cantidades.length; i++) {
            datosPlan[pf].sumaHor += datosPlan[pf].cantidades[i];
        }

        // -- suma vertical
        sumaVer[ps] = 0;
        for (let i = 0; i < datosPlan.length; i++) {
            sumaVer[ps] += +datosPlan[i].cantidades[ps];
        }
        // -- actualizamos
        updateDatosPlan([...datosPlan]);
        updateSumVer(sumaVer);

        //-- enviar la actualización al servidor
        axios
            .post(API_URL + "/updatePlanv2", {
                tipoFlorId: datosPlan[pf].tipoFlorId,
                florId: datosPlan[pf].florId,
                cantidad,
                pf,
                ps,
            })
            .then((r) => console.log(r))
            .catch((err) => console.log(err));
    }

    const handlerChange = (e) => {
        console.log(e.target.value);
        setFlor({
            ...flor,
            [e.target.name]: e.target.value,
        });
    };

    const onSubmit = (e) => {
        e.preventDefault();
        if (+flor.flor > 0) {
            updateLoader(true);
            axios.post(API_URL + "/set_plan", flor).then((r) => {
                console.log(r);
                getPlanes();
                updateLoader(false);
            });
        } else {
            ToastsStore.error("Selecccione una Flor!");
        }
    };

    // -- eliminando la flor del plan
    const actionModal = () => {
        console.log(infoFlor);
        updateLoader(true);
        axios
            .post(API_URL + "/removerFlorPlan", {florId: infoFlor.florId})
            .then((r) => {
                updateLoader(false);
                modalRef.current.hideModal();
                getPlanes();
                console.log(r);
            })
            .catch((err) => console.log(err));
    };

    return (
        <div className="w-full p-3 my-auto">
            <div className="bg-white border rounded shadow-xl border border-orange-700">
                <div className="p-5 rounded-b">
                    {/** selector de flores */}
                    <form className="ml-3" onSubmit={onSubmit}>
                        <div className="flex flex-wrap -mx-3 mb-6">
                            <div className="w-full md:w-1/4 mb-6 md:mb-0">
                                <SelectFlores name="flor" onChange={handlerChange}/>
                            </div>

                            <div className="w-1/4 mx-2 my-1">
                                <button
                                    className="text-sm bg-orange-800 hover:bg-orange-700 text-white py-2 px-4 rounded shadow focus:outline-none">
                                    Agregar
                                </button>
                            </div>
                        </div>
                    </form>
                    {/** Tabla del Plan de Cosecha */}
                    <h3 className="mx-1 my-1 font-bold text-orange-900 mt-3">Año 2020</h3>
                    <div className="w-full shadow-xl rounded m-auto">
                        <div className="wrapper">
                            <table className="table-auto mb-3">
                                <thead>
                                <tr className="bg-orange-900 text-white">
                                    <th className="text-center text-sm w-32 border border-orange-900 bg-orange-900 px-2 my-px sticky-col first-col">
                                        Flor
                                    </th>
                                    <th className="text-center text-sm w-32 border border-orange-900 bg-orange-900 px-2 my-px sticky-col second-col">
                                        Totales
                                    </th>
                                    {[...Array(52)].map((x, i) => {
                                        return (
                                            <th
                                                key={i}
                                                className="bg-orange-900 border-orange-900 text-center text-sm text-white border overflow-hidden px-2 my-px"
                                            >
                                                {(i + 1 + "").padStart(2, "0")}
                                            </th>
                                        );
                                    })}
                                </tr>
                                </thead>
                                <tbody>
                                {datosPlan.map((d, i) => {
                                    return (
                                        <tr key={i}>
                                            <td className="w-32 text-sm text-orange-900 border border-orange-900 bg-orange-100 font-bold px-2 my-px sticky-col first-col">
                                                  <span className="mt-2">
                                                    {d.nombre + " " + d.variedad + " (" + d.color + ")"}
                                                  </span>{" "}
                                                <br/>
                                                <button
                                                    className="text-xs bg-blue-700 hover:bg-blue-600 text-white py-1 px-1 my-1 rounded shadow focus:outline-none"
                                                    onClick={() => {
                                                        setInfoFlor(d);
                                                        modalRef.current.showModal();
                                                    }}
                                                >
                                                    <i className="fas fa-trash-alt"/> Remover
                                                </button>
                                                <button
                                                    className="text-xs bg-blue-700 hover:bg-blue-600 text-white py-1 px-1 my-1 ml-2 rounded shadow focus:outline-none">
                                                    <i className="fas fa-history"/> Historial
                                                </button>
                                            </td>
                                            <td className="w-32 text-sm text-right text-orange-900 border border-orange-900 bg-orange-100 font-bold px-2 my-px sticky-col second-col">
                                                {new Intl.NumberFormat("en-EN").format(+d.sumaHor)}
                                            </td>
                                            {d.cantidades.map((c, j) => {
                                                return (
                                                    <td
                                                        key={j}
                                                        className="text-center text-sm text-orange-900 border-orange-900 font-bold border overflow-hidden px-2 my-px py-1"
                                                    >
                                                        {/* new Intl.NumberFormat('en-EN').format(c) */}
                                                        <CantidadPlan
                                                            cantidad={c}
                                                            pf={i}
                                                            ps={j}
                                                            fn={actualizarDatos}
                                                        />
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    );
                                })}
                                </tbody>
                                <tfoot>
                                <tr className="text-sm">
                                    <th
                                        className="text-right bg-orange-900 border border-orange-900 sticky-col first-col"
                                        colSpan="2"
                                    ></th>
                                    {sumaVer.map((c, i) => {
                                        return (
                                            <th
                                                key={i}
                                                className={
                                                    +c > 0
                                                        ? "text-center text-sm text-orange-900 border-orange-900 bg-orange-100 font-bold border overflow-hidden px-2 my-px"
                                                        : "text-center text-sm border border-orange-700 overflow-hidden px-2 my-px"
                                                }
                                            >
                                                {new Intl.NumberFormat("en-EN").format(c)}
                                            </th>
                                        );
                                    })}
                                </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            {loader && <MyLoader/>}
            <ToastsContainer
                store={ToastsStore}
                position={ToastsContainerPosition.TOP_RIGHT}
            />

            {/* Modal */}
            <Modal
                titulo="Remover Flor"
                mensaje={`¿Seguro de Remover la flor: ${infoFlor.nombre} ${infoFlor.variedad} (${infoFlor.color}), del Plan de Cosecha?`}
                ref={modalRef}
                actionTitle="Remover"
                actionFn={actionModal}
            />
        </div>
    );
};

export default PlanCosechaGenerados;
